export const colors = {
  brand: '#f4f7f6',
  defaultFontColor: '#212121',
}



// WEBPACK FOOTER //
// ./src/styles/variables.js